import { api } from '@/services'

export const updateProfile = (params) => {
  return api.post('web/user/updateProfile', params)
}

export const updateLanguage = (params) => {
  return api.post('web/user/updateLanguage', params)
}

export const impersonate = (params) => {
  return api.post('admin/user/impersonate', params)
}
